import { render, staticRenderFns } from "./MorphologyTable.vue?vue&type=template&id=7e6ccbd6&scoped=true&"
import script from "./MorphologyTable.vue?vue&type=script&lang=js&"
export * from "./MorphologyTable.vue?vue&type=script&lang=js&"
import style0 from "./MorphologyTable.vue?vue&type=style&index=0&id=7e6ccbd6&prod&lang=scss&"
import style1 from "./MorphologyTable.vue?vue&type=style&index=1&id=7e6ccbd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6ccbd6",
  null
  
)

export default component.exports